<template>
  <div class="container-full search-result d-flex">
      <div v-if="showCommunities" class="hide-communities btn btn-light" @click="showCommunities = false">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 26L10 16L20 6" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </div>
      <div :class="{colpanel: true, 'py-5': true, 'results': true, 'hide-panel': !showCommunities}">
          <div class="my-2">
            <a href="/" class="btn btn-flat">
              <svg width="24" height="20" viewBox="0 0 32 32" fill="none">
              <path d="M20 26L10 16L20 6" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Back to Home
            </a>
          </div>
          <h3 v-if="city">Communities in {{city.city}}</h3>
          <h3 v-if="!city">Communities near you</h3>
          <div v-if="localFilters && localFilters.type.filter.length > 0" class="filters">
              <div
                @click="toggleFilter(filter)"
                v-for="(filter, i) in localFilters.type.filter" :key="i"
                :class="classForFilter(filter)">{{filter.text}}</div>
          </div>
          <div v-if="pages.length > 0" class="pagination">
              <div
                @click="currentPage = pageItem"
                v-for="pageItem in pages"
                :key="pageItem"
                :class="{ 'btn': true, 'btn-light': pageItem != currentPage, 'btn-dark': pageItem == currentPage  }">
                  {{pageItem}}
              </div>
          </div>

          <div class="item d-flex" v-for="(item, i) in page" :key="i">
              <a :href="'/' + item.slug + '/'" class="d-md-flex">
                  <img :src="item.thumbnail" />
                  <div class="description">
                      <h3> {{item.title}}</h3>
                      <h4> {{item.university_name}}</h4>
                      <p> {{item.small_description}} </p>
                  </div>
              </a>
          </div>
          <div  class="item d-flex" v-if="filterResult.length == 0">
              <div class="d-md-flex">
                  <img src="/static/communities/no-result.jpg" />
                  <div class="description">
                      <h3> Bummer! StoryFaith isn’t here yet. </h3>
                      <h4></h4>
                      <p> But we will soon! Sign up to StoryFaith to stay connected and get notified when we are. </p>
                      <p><a class="btn btn-yellow my-2" href="/accounts/signup">Sign Up</a></p>
                  </div>
              </div>
          </div>
      </div>
      <div class="colpanel map h-100">
          <div class="btn btn-light show-communities" @click="showCommunities = true">
            <svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6L22 16L12 26" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Show communities
          </div>
          <div id="map-output"></div>
      </div>
  </div>
</template>
<script>
import { getCookie } from '../client'
import 'whatwg-fetch'

const csrftoken = getCookie('csrftoken');


const mapboxgl = window.mapboxgl;
if (mapboxgl)
    mapboxgl.accessToken = 'pk.eyJ1IjoibXNheHRvbiIsImEiOiJja3FtdWx2ZXowZGliMnJzYnVicW1uMzdrIn0.HbGh0raLDM3Ga7jEied-kw';

function renderMap(city, result) {
    if (!document.getElementById("map-output")) return;
    var map = new mapboxgl.Map({
        container: 'map-output',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [city.lng, city.lat],
        zoom: 13
    });
    var west = null, south = null, east = null, north = null;
    result.forEach( (item) => {
        let coords = item.location.split(",");
        let latitude = parseFloat(coords[0]);
        let longitude = parseFloat(coords[1]);

        if (west === null || longitude < west) west = longitude;
        if (east === null || longitude > east) east = longitude;
        if (south === null || latitude < south) south = latitude;
        if (north === null || latitude > north) north = latitude;

        var marker = new mapboxgl.Marker({ color: 'black' })
          .setLngLat([longitude, latitude])
          .setPopup(new mapboxgl.Popup().setHTML("<h4>" + item.title + "</h4>"));
        marker.addTo(map);
    });

    if (west !== null) {
        map.fitBounds([ [west, south], [east, north] ], {
            padding: window.innerWidth * 0.10
        });
    }
}

export default {
    name: 'MapResults',
    props: {
        result: Array,
        city: Object,
        filters: Object,
        username: String
    },
    data () {
        return {
            showCommunities: false,
            currentPage: 1,
            pageSize: 15,
            localFilters: this.filters
        }
    },
    mounted: function () {
        // var self = this;
        this.$nextTick(function () {
            renderMap(this.city, this.result);
        });
    },
    methods : {
        favorite (index) {
            if (!this.username) return;
            var self = this;
            var data = new FormData();
            data.append("community", this.result[index].slug);
            fetch("/api/account/" + this.username + "/favoritecommunity/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrftoken
                },
                body: data
            }).then(async function (result) {
                if (result.status == 200) {
                    self.result[index].favorited = !self.result[index].favorited;
                }
            });
        },
        classForFilter (filter) {
            let all = this.filters.type.filter.reduce( (accumulator, item) => { return item.on && accumulator; }, true);
            return {
                'btn': true,
                'btn-light': all || !filter.on,
                'btn-dark': !all && filter.on
            };
        },
        toggleFilter (filter) {
            let all = this.filters.type.filter.reduce( (accumulator, item) => { return item.on && accumulator; }, true);
            if (all || !filter.on) {
                this.filters.type.filter.forEach( (item) => {
                    item.on = false;
                });
                filter.on = true;
            }
            else {
                this.filters.type.filter.forEach( (item) => {
                    item.on = true;
                });
            }
        }
    },
    computed: {
        filterResult () {
            let enabledTypes = this.filters.type.filter.map( (typeFilter) => typeFilter.on?typeFilter.text:undefined );
            return this.result.filter((item) => {
                return enabledTypes.indexOf(item.type) != -1;
            });
        },
        page () {
            return this.filterResult.slice((this.currentPage-1) * this.pageSize, (this.currentPage)*this.pageSize);
        },
        pages () {
            var pages = [], n = Math.ceil(this.filterResult.length / this.pageSize);
            for (let i = 1; i <= n; i++) pages.push( i );
            return pages;
        }
    }
}
</script>
<style scoped>
.colpanel {
    width: 50%;
    background: white;
}
.show-communities, .hide-communities {
    display: none;
}

.search-result {
    height: 90vh;
    width: 100%;
    margin-bottom: -15px;
}
#map-output {
    height: 100%;
}
h3 {
    text-align: left;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 10px;
}
.colpanel.results {
    padding: 20px;
    overflow-y: scroll;
}
.item img {
    width: 30%;
    height: 180px;
    max-width: 180px;
    min-width: 180px;
    object-fit: cover;
    border-radius: 10px;
    margin: 10px 0px;
}
.item .description {
    padding: 20px;
}
.item h3 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 1em;
    margin-bottom: 10px;
}
.item h4 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 10px;
}
.item p {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
}
.item .side-bar {
    padding: 20px 0px;
}
a {
    text-decoration: none;
}


@media(max-width: 1050px) {
    .show-communities {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 2;
        display: block;
        padding: 10px;
    }
    .hide-communities {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
        display: block;
        padding: 5px;
    }
    .search-result {
        overflow: hidden;
        position: relative;
    }
    .colpanel.results {
        width: 80%;
        height: 100%;
    }
    .colpanel {
        width: 100%;
        z-index: 1;
        position: absolute;
        top: 0px;
        left: 0px;
    }
    .hide-panel {
        display: none;
    }
    .colpanel.map {
        z-index: 0;
    }

    .item img {
        width: 80%;
        height: 150px;
        margin-left: 0px;
        object-fit: cover;
    }
}

.filters, .pagination {
    margin-bottom: 10px;
    margin-left: 0;
    margin-top: 0;
    padding: 0;
}

.filters .btn.btn-light, .pagination .btn.btn-light {
    background: white;
    border: 1px solid #999;
    color: #444;
}

.filters .btn, .pagination .btn {
    margin-right: 10px;
}

</style>
